import styled from 'styled-components'
import { SecondaryButton } from '../../../shared/Buttons/Buttons.styles'

export const SocialMediaContainer = styled.div`
  display: ${props => props.mobileOnly ? 'block' : 'none'};
  margin-top: 6.4rem;
  text-align: center;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: ${props => props.mobileOnly ? 'none' : 'block'};
    margin-top: 2rem;
    text-align: left;
  }
`

export const ShareLink = styled.a`
  display: inline-block;
  margin-left: 3.5rem;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-left: 1.2rem;
  }

  svg {
    color: ${props => props.theme.colors.black};
    height: 34px;
    width: 34px;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      height: 18px;
      width: 18px;
    }
  }
`

export const CopyModal = styled.div`
  background: ${props => props.theme.colors.white};
  font-size: 1.4rem;
  padding: 3rem 2rem 2rem;
  border-radius: 2px;
  position: fixed;
  min-width: calc(100% - 4rem);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  z-index: 99;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  transition: 0.2s all;
  opacity: ${props => (props.visible ? '1' : '0')};
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    min-width: inherit;
    max-width: 400px;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.6;
    margin: 0 0 2rem 0;
  }
`

export const ModalBG = styled.div`
  &::before {
    content: "";
    transition: 0.2s all;
    opacity: ${props => (props.visible ? '0.8' : '0')};
    background: rgba(0, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${props => (props.visible ? '10' : '-1')};
  }
`

export const ModalButton = styled(SecondaryButton)`
  button {
    padding: 0.5rem 1.1rem;

    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`
